<template>
  <transition>
    <label class="template content-type" :style="labelStyle">{{contentType}}</label>
  </transition>
</template>

<script>

import mixin from './mixin.js'
export default {
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
@import "~styles/utils.scss";

.template {
  background-color: $primary;
  color: #fff;
  font-weight: 0.65rem;
  z-index: 5;
  background-color: $primary;
  text-transform: capitalize;
  max-height: 1.7rem;
  padding: .1rem 1.2rem;
  @include mobile {
    font-size: 0.7rem;
  }
}

</style>
